import React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { LoadingSpinnerModal } from '.';
import { handleGetWaitOnAction, handleLogout, getSessionTimeout, renewToken, handleAutoLogout, getRenewalInProgress, setRenewalInProgress, getRenewalWaitingTime, getRenewalAllowedTime, getRenewalStartingTime  } from "../../pages/common/functions";
import { useFrontContext } from '../../providers/frontContext';
import { getAuthData, getUserAccessToken } from '../../services/selectors/Accounts';

export default function ()
{
	let timeout = getSessionTimeout();
	var isRenewalInProgress: boolean;
	var isWaitOnAction: boolean;
	isWaitOnAction = handleGetWaitOnAction();

	const context = useFrontContext();
	const recipientEmail = (context && context.conversation && context.conversation.recipient) ? context.conversation.recipient.handle : "";

	React.useEffect(() => {
		handleOnAction();
	}, [recipientEmail])
	
	const handleOnAction = () => {
		var sessionExpiry = window.localStorage.getItem('SESSIONEXPIRY');
		if (Date.now() > Number(sessionExpiry)){			
			handleValidateToRenewal(sessionExpiry);
		}
	}

	const handleValidateToRenewal = (sessionExpiry) => {
		if (typeof (isRenewalInProgress) === 'undefined' || isRenewalInProgress == null) {
			isRenewalInProgress = getRenewalInProgress();
		}

		var authData = getAuthData();
		var accessToken = getUserAccessToken();

		if (authData == null || accessToken == null) {
			isWaitOnAction = true;
			handleAutoLogout();
		}
		else {
			if (isRenewalInProgress){
				isWaitOnAction = false;
				if (Date.now() > (Number(sessionExpiry) + getRenewalWaitingTime())) {
					isWaitOnAction = true;
					handleAutoLogout();
				}
			}
			else {
				if (Date.now() < (Number(sessionExpiry) + getRenewalAllowedTime())) {
					isWaitOnAction = false;
					isRenewalInProgress = true;
					setRenewalInProgress(isRenewalInProgress);
					handleNextSession();
				}
				else {
					isWaitOnAction = true;
					handleAutoLogout();
				}
			}
		}
	}

	const { } = useIdleTimer({
		timeout,
		events: [
			'mousemove',
			'keydown',
			'wheel',
			'DOMMouseScroll',
			'mousewheel',
			'mousedown',
			'touchstart',
			'touchmove',
			'MSPointerDown',
			'MSPointerMove',
			'visibilitychange',
			'load',
			'click',
			'keypress',
			'loadeddata',
			'loadedmetadata',
			'loadstart',
			'dblclick'
		],
		onIdle: handleOnAction,
		onAction: handleOnAction
	})

	async function handleNextSession(){
		let isSuccess = await renewToken();
		if (isSuccess) {
			 timeout = getSessionTimeout();
			 isRenewalInProgress = false;
			 setRenewalInProgress(isRenewalInProgress);
		}
		 else {
			handleLogout(true);
		}
	}

	return (
		<div>
			{isWaitOnAction && (<LoadingSpinnerModal isShowModal={isWaitOnAction} modalChange={() => { }} />)}
		</div>
	)
}